var map = {
	"./delivery-login/delivery-login.module": [
		"./src/app/lazy/public/delivery-login/delivery-login.module.ts",
		"common",
		"delivery-login-delivery-login-module"
	],
	"./delivery/delivery.module": [
		"./src/app/lazy/private/delivery/delivery.module.ts",
		"delivery-delivery-module"
	],
	"./lazy/lazy.module": [
		"./src/app/lazy/lazy.module.ts",
		"lazy-lazy-module"
	],
	"./login/login.module": [
		"./src/app/lazy/public/login/login.module.ts",
		"default~login-login-module~sales-sales-module",
		"common",
		"login-login-module"
	],
	"./order/order.module": [
		"./src/app/lazy/private/pos/order/order.module.ts",
		"order-order-module"
	],
	"./pos/pos.module": [
		"./src/app/lazy/private/pos/pos.module.ts",
		"pos-pos-module"
	],
	"./private/private.module": [
		"./src/app/lazy/private/private.module.ts",
		"private-private-module"
	],
	"./public/public.module": [
		"./src/app/lazy/public/public.module.ts",
		"public-public-module"
	],
	"./sales/sales.module": [
		"./src/app/lazy/private/pos/sales/sales.module.ts",
		"default~login-login-module~sales-sales-module",
		"common",
		"sales-sales-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;